import React, { useState, useEffect } from "react";
import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import EditIcon from "@material-ui/icons/Edit";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { compose } from "redux";
import {
  changeReferralCode,
  storeProfile,
  submitAuthCode,
} from "../../../actions/actionCreators";
import {
  CHANGE_AUTH_CODE,
  CHANGE_AUTH_PHONE,
  CHANGE_PROFILE_INPUT,
  SHOW_PHONE_ALERT,
} from "../../../actions/actionsTypes";
import convertDigits from "../../../components/convertDigits";
import i18n from "../../../i18nextInitiator";
import ButtonWithLoading from "../ButtonWithLoading";
// import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core";

/**
 * translation function.
 * @type {TFunction}
 */
const t = i18n.getFixedT("fa", "general");

/**
 * JSS
 * @param theme
 * @return {{input: {"& input": {"&[type=number]": {"-moz-appearance": string, "-webkit-appearance": string}, "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {"-moz-appearance": string, margin: number, "-webkit-appearance": string}}}, root: {padding: string, backgroundColor: (string|string), position: string, zIndex: number}, box: {margin: string, "& > *": {margin: string}, maxWidth: number}}}
 */
const useStyles = makeStyles((theme) => ({
  input: {
    "& input": {
      fontSize: "16px",
      textAlign: "center",
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        "-moz-appearance": "none",
        margin: 0,
      },
      // '&[type=number]': {
      //     '-webkit-appearance': 'textfield',
      //     '-moz-appearance': 'textfield'
      // }
    },
  },
  largerText: {
    fontSize: "1rem",
  },
}));
const AuthInput = ({ sendCode, counter }) => {
  const classes = useStyles();
  const inputRef = React.createRef();
  const authRef = React.createRef();
  // const { executeRecaptcha } = useGoogleReCaptcha();
  // const handleVerifyRecaptcha = async () => {
  //   const { executeRecaptcha } = this.props.googleReCaptchaProps;
  //   if (!executeRecaptcha) {
  //     console.log("Recaptcha has not been loaded");
  //     return;
  //   }
  //   const token = await executeRecaptcha("homepage");
  // };

  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  useEffect(() => {
    if (inputRef && inputRef.current.focus) inputRef.current.focus();
  }, []);
  const changeAuthPhone = (e) => {
    dispatch({
      type: CHANGE_AUTH_PHONE,
      value: convertDigits(e.target.value).replace(/\D/g, ""),
    });
  };
  const changeAuthCode = (e) => {
    dispatch({
      type: CHANGE_AUTH_CODE,
      value: convertDigits(e.target.value).replace(/\D/g, ""),
    });
  };
  const showPhoneAlert = (e) => {
    dispatch({ type: SHOW_PHONE_ALERT });
  };
  const changeProfileInput = (e) => {
    dispatch({
      type: CHANGE_PROFILE_INPUT,
      value: e.target.value,
      name: e.target.name,
    });
  };
  const autoFill = (code) => {
    dispatch({
      type: CHANGE_AUTH_CODE,
      value: code,
    });
  };
  const {
    order: { inProgress },
    auth: {
      profile: { name = "", share_code } = {},
      asyncVerifyLogin,
      storingProfile,
      authPhone,
      correctPhone,
      phoneAlert,
      verifyAlert,
      authCode,
      // authCodeError,
    },
  } = state;
  console.log(state);
  const phoneEnteredButNotCorrect =
    authPhone && authPhone.length > 10 && !correctPhone;
  const authCodeValid = !state.authCodeError && authCode.length > 3;
  /**
   * regex for entering only numbers in persian and english.
   * @type {string}
   */
  const phoneInputPattern = "/^09d{9}|۰۹[\u06F0-\u06F90-9]{9}$/";

  if (phoneAlert)
    return (
      <>
        <Typography color={"primary"} variant={"h6"} align={"center"}>
          {t("auth.enter-phone")}
        </Typography>

        <TextField
          fullWidth
          type="text"
          inputMode="numeric"
          variant={"outlined"}
          inputProps={{ pattern: phoneInputPattern, type: "tel" }}
          inputRef={(ref) => (inputRef.current = ref)}
          onChange={changeAuthPhone}
          value={authPhone}
          error={phoneEnteredButNotCorrect}
          className={classes.input}
          name="phone"
          label={t("auth.phone-number")}
          helperText={
            phoneEnteredButNotCorrect ? t("auth.phone-incorrect") : ""
          }
        />
        <ButtonWithLoading
          type="submit"
          disabled={!correctPhone}
          text={t("submit")}
          action={sendCode}
          loading={inProgress}
        />
        <Typography className="privacy">
          {t("auth.by-registering")}
          <Link to={"/terms-and-conditions"}>
          <Button
            variant={"text"}
            color={"primary"}
            // href={"/terms-and-conditions"}
          >
            {t("auth.terms")} و {t("auth.privacy")}
          </Button>
          </Link>
          {t("auth.i-accept")}
        </Typography>
      </>
    );

  if (verifyAlert)
    return (
      <>
        <Typography color={"primary"} variant={"h6"} align={"center"}>
          {t("auth.code-has-been-sent.0")}
          <Chip
            onClick={showPhoneAlert}
            icon={<EditIcon />}
            color={"secondary"}
            label={authPhone}
            className={classes.largerText}
          />
          {t("auth.code-has-been-sent.1")}
        </Typography>
        <Typography>{t("auth.didnt-receive-code")}</Typography>

        {counter > 1 ? (
          <>
            <Typography>
              {t("auth.wait-send-again.0")}
              <Typography color={"primary"} component={"span"}>
                {" "}
                {counter}{" "}
              </Typography>
              {t("auth.wait-send-again.1")}
            </Typography>
          </>
        ) : (
          <Button
            variant={"outlined"}
            color={"primary"}
            className={classes.largerText}
            onClick={sendCode}
          >
            {t("auth.send-again")}
          </Button>
        )}

        <TextField
          fullWidth
          autoComplete="one-time-code"
          variant={"outlined"}
          label={t("auth.code")}
          onChange={changeAuthCode}
          inputRef={(ref) => (authRef.current = ref)}
          type="number"
          inputMode="numeric"
          value={authCode}
          error={state.authCodeError}
          className={classes.input}
          helperText={state.authCodeError ? t("auth.incorrect-code") : ""}
        />

        <Typography className="privacy-verify">
          {t("auth.by-registering")}
          <Link to={"/terms-and-conditions"}>
          <Button
            variant={"text"}
            color={"primary"}
            // href={"/terms-and-conditions"}
          >
            {t("auth.terms")}
          </Button>
          </Link>
          {t("auth.i-accept")}
        </Typography>
        {/* <button onClick={handleVerifyRecaptcha}>Verify Recaptcha</button> */}
        <ButtonWithLoading
          disabled={!authCodeValid}
          text={t("auth.login")}
          action={submitAuthCode}
          loading={asyncVerifyLogin}
        />
      </>
    );
  return (
    <>
      <TextField
        fullWidth
        variant={"outlined"}
        onChange={changeProfileInput}
        value={name}
        name="name"
        label={t("auth.names")}
      />
      <TextField
        fullWidth
        variant={"outlined"}
        onChange={changeReferralCode}
        value={share_code || ""}
        name="referral-code"
        label={t("auth.referral-code")}
      />

      <ButtonWithLoading
        id="register-new-user"
        text={t("submit")}
        action={storeProfile}
        loading={storingProfile}
      />
    </>
  );
};
export default AuthInput;
